<script>
    import router from '@/router';
    import store from '@/store';
    import KeenTracking from 'keen-tracking';
    import MobileDetect from 'mobile-detect';
    import verge from 'verge';

    export default {
        name: 'WebsiteStatistics',
        render() {
            return null;
        },
        data() {
            return {
                client: null,
                keenStream: String(process.env.VUE_APP_KEEN_RAW_STREAM),
                keenAddon: {
                    addons: [
                        {
                            name: 'keen:ip_to_geo',
                            input: {
                                ip: 'ipAddress'
                            },
                            output: 'geo'
                        },
                        {
                            name: 'keen:url_parser',
                            input: {
                                url: 'urlCurrent'
                            },
                            output: 'urlParsed'
                        }
                    ]
                },
                sessionDuration: 7200, // In seconds (86400=1day, 3600=1hour)
                longestVisit: 3600, // In Seconds (3600=1hour)
                consuming: {
                    session: null,
                    order: 0,
                    timeSpent: 1,
                    isVisible: true
                },
                context: {
                    documentWidth: 0,
                    documentHeight: 0,
                    viewportWidth: 0,
                    viewportHeight: 0,
                    scrollTopY: 0,
                    scrollTopYMax: 0,
                    scrollBottomY: 0,
                    scrollBottomYMax: 0,
                    consumed: 0
                },
                tech: {
                    isBot: false,
                    device: ''
                },
                contextElement: document.getElementById('Wrapper')
            };
        },
        beforeDestroy() {
            this.hiddenMode();
        },
        mounted() {
            // Define a client instance
            this.keenInit();
        },
        computed: {
            keen() {
                if (store.state.websiteSettings !== null) {
                    return store.state.websiteSettings.keen;
                }
                return null;
            },
            consumer() {
                if (store.state.consumer !== null) {
                    return {
                        anonymous: false,
                        relmKey: store.state.consumer.relmKey,
                        sharedKey: store.state.consumer.sharedKey,
                        step: store.state.consumer.step,
                        isTargeted: store.state.consumer.isTargeted,
                        sharedOn: store.state.keenInfos.sharedOn,
                        doNotTrack: this.dnt
                    };
                } else {
                    return {
                        anonymous: true,
                        doNotTrack: this.dnt
                    };
                }
            },
            dnt() {
                return store.state.keenInfos.doNotTrack;
            },
            currentPage() {
                const currentArticle = (router.app._route.matched[0].props.default.type === 'article' && store.state.currentArticle !== null) ? {
                    slug: store.state.currentArticle.slug,
                    order: store.state.currentArticle.order,
                    bj: store.state.currentArticle.step,
                    private: (store.state.currentArticle.isPublic === 1) ? 'false' : 'true'
                } : null;
                return {
                    type: router.app._route.matched[0].props.default.type,
                    title: (currentArticle === null) ? router.app._route.matched[0].props.default.stats : store.state.currentPageTitle,
                    article: currentArticle
                };
            },
            vis() {
                var stateKey, eventKey;
                const keys = {
                    hidden: 'visibilitychange',
                    webkitHidden: 'webkitvisibilitychange',
                    mozHidden: 'mozvisibilitychange',
                    msHidden: 'msvisibilitychange'
                };
                for (stateKey in keys) {
                    if (stateKey in document) {
                        eventKey = keys[stateKey];
                        break;
                    }
                }
                return function (c) {
                    if (c) {
                        document.addEventListener(eventKey, c);
                        //document.addEventListener("blur", c);
                        //document.addEventListener("focus", c);
                    }
                    return !document[stateKey];
                };
            }
        },
        watch: {
            '$route': function () {
                this.consuming.timeSpent = 1;
                this.consuming.order++;
                this.updateContext(true);
                if (this.client === null && this.keen !== null) {
                    this.keenInit();
                }
                this.session();
            }
        },
        methods: {
            keenInit() {
                const mobileDetect = new MobileDetect(window.navigator.userAgent);
                this.tech.isBot = mobileDetect.is('bot');
                this.tech.device = mobileDetect.tablet() ? 'tablet' : mobileDetect.mobile() ? 'mobile' : 'desktop';

                if (store.state.keenInfos.hidden) {
                    this.hiddenMode();
                } else {
                    // Initialize
                    if (this.client === null && this.keen !== null) {
                        this.client = new KeenTracking({
                            projectId: this.keen.projectId, // store.state.keenAccess.projectId,
                            writeKey: this.keen.writeKey, // store.state.keenAccess.writeKey,
                            requestType: 'fetch' // fetch, beaconAPI, img
                        });
                        KeenTracking.enabled = true;
                        KeenTracking.debug = false;
                        this.client.on('recordEvent', KeenTracking.log);

                        // Start RealTime Timer
                        this.$options.intervalRT = setInterval(this.trackRealTime, 1000);
                        this.session();
                    }
                }
            },
            // Sessions management
            session() {
                if (store.state.session.id !== null && store.state.session.createdAt !== null && Math.round((new Date() - new Date(store.state.session.createdAt)) * .001) < this.sessionDuration) {
                    store.dispatch('keepSession');
                } else {
                    store.dispatch('newSession', KeenTracking.helpers.getUniqueId());
                }
            },
            // Clear data
            hiddenMode(quite = false) {
                // Don't record anything
                if (!quite) console.log('Hidden Mode. No statistics recording.');
                clearInterval(this.$options.intervalRT);
            },
            updateContext(clean = false) {
                if (clean) {
                    this.context.scrollTopYMax = 0;
                    this.context.scrollBottomYMax = 0;
                }
                const contextSize = verge.rectangle(this.contextElement);
                this.context.documentWidth = parseFloat(Number(contextSize.width).toFixed(0));
                this.context.documentHeight = parseFloat(Number(contextSize.height).toFixed(0));
                this.context.viewportWidth = parseFloat(Number(parseFloat(verge.viewport().width).toFixed(0)));
                this.context.viewportHeight = parseFloat(Number(parseFloat(verge.viewport().height).toFixed(0)));
                this.context.scrollTopY = Math.abs(parseFloat(Number(parseFloat(contextSize.top).toFixed(0))));
                this.context.scrollTopYMax = this.context.scrollTopY > this.context.scrollTopYMax ? this.context.scrollTopY : this.context.scrollTopYMax;
                this.context.scrollBottomY = this.context.scrollTopY + this.context.viewportHeight;
                this.context.scrollBottomYMax = this.context.scrollBottomY > this.context.scrollBottomYMax ? this.context.scrollBottomY : this.context.scrollBottomYMax;
                this.context.consumed = parseFloat(Number(this.context.scrollBottomYMax / this.context.documentHeight * 100).toFixed(0));

                if (this.context.consumed < 0) {
                    this.context.consumed = 0;
                }
                if (this.context.documentHeight <= this.context.viewportHeight || this.context.consumed > 100) {
                    this.context.consumed = 100;
                }
                /*
                console.log(
                    'documentWidth', this.context.documentWidth,
                    'documentHeight', this.context.documentHeight,
                    'viewportWidth', this.context.viewportWidth,
                    'viewportHeight', this.context.viewportHeight,
                    'scrollTopY', this.context.scrollTopY,
                    'scrollTopYMax', this.context.scrollTopYMax,
                    'scrollBottomY', this.context.scrollBottomY,
                    'scrollBottomYMax', this.context.scrollBottomYMax,
                    'consumed', this.context.consumed,
                );
                */
            },
            // Realtime tracking
            trackRealTime() {
                if (this.dnt) this.trackDNT();
                else {
                    this.updateContext();
                    const isVisible = (typeof this.vis() === 'boolean') ? this.vis() : null;
                    if (isVisible === false) {
                        this.consuming.timeSpent = 1;
                    }
                    if (isVisible !== false) {
                        const event = {
                            consumer: this.consumer,
                            tech: this.tech,
                            ipAddress: '${keen.ip}',
                            userAgent: '${keen.user_agent}',
                            urlCurrent: window.document.location.href.toString(),
                            keen: this.keenAddon,
                            consuming: {
                                session: store.state.session.id,
                                page: this.currentPage,
                                order: this.consuming.order,
                                timeSpent: this.consuming.timeSpent++,
                                isVisible: isVisible
                            },
                            context: this.context
                        };
                        if (!(event.consuming.page.type === 'article' && event.consuming.page.article === null)) {
                            this.client.recordEvent(this.keenStream, event);
                        }
                        if (this.consuming.timeSpent > this.longestVisit) {
                            clearInterval(this.$options.intervalRT);
                            this.client = null;
                        }
                    }
                }
            },
            // Record Do Not Track Event
            trackDNT() {
                this.client.recordEvent(this.keenStream, {
                    consumer: this.consumer,
                    tech: {
                        isBot: this.tech.isBot
                    }
                });
                this.hiddenMode();
            }
        }
    };
</script>
